@if (isStringIcon()) {
    <i [class]="icon"></i>
} @else {
    <fa-icon [icon]="faIcon" (click)="onClick($event)" />
}